var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"OverviewBox"},[_c('h1',[_vm._v("Overview")]),_c('ul',_vm._l((_vm.types),function(type,idx){return _c('li',{key:idx},[_vm._v(_vm._s(type.title))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }